const translations = {
    createProductUsageReport: 'Create Product Usage Report'
};

export default translations;
